import dropify from 'dropify'
import 'dropify/dist/css/dropify.css';

document.addEventListener("DOMContentLoaded", function() {

  $('.js-dropify').dropify();

});